import { SET_STORE_ADDRESS } from "../actions/types";

const initialState = {
    storeAddress: {},
};

export default (state = initialState, action = {}) => {

    switch (action.type) {
        case SET_STORE_ADDRESS:
            return {
                storeAddress: action.storeAddresses
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/reducers/storeAddress.js